
import { RootState } from '../../store';

export const selectWorkerReports = (state: RootState) => state.reports.workerReports.data;
export const selectWorkerReportsCount = (state: RootState) => state.reports.workerReports.count;
export const selectWorkerReportsLoading = (state: RootState) => state.reports.workerReports.loading;
export const selectWorkerReportsError = (state: RootState) => state.reports.workerReports.error;

export const selectWorkerReportStatistics = (state: RootState) => state.reports.workerReportStatistics?.data || { total_workers: 0, overtime_workers: 0 };
export const selectWorkerReportStatisticsLoading = (state: RootState) => state.reports.workerReportStatistics?.loading;

